import type { LoginDto, LoginResponse, RegisterDto, RegisterResponse, User } from '@/types/user'
import { ENDPOINTS } from './endpoints'
import { http } from './http'
import type { ApiResponse } from './http/types'

export interface ChangePasswordDto {
  current_password: string
  new_password: string
  new_password_confirmation: string
}

export const authService = {
  login(payload: LoginDto) {
    return http.post<ApiResponse<LoginResponse>>(ENDPOINTS.auth.login, payload)
  },
  register(payload: RegisterDto) {
    return http.post<ApiResponse<RegisterResponse>>(ENDPOINTS.auth.register, payload)
  },
  logout() {
    return http.post<ApiResponse<void>>(ENDPOINTS.auth.logout)
  },
  me() {
    return http.get<ApiResponse<User>>(ENDPOINTS.auth.me)
  },
  /** Call /auth/me with an explicit Bearer token (cross-port handoff). */
  meWithToken(token: string) {
    return http.get<ApiResponse<User>>(ENDPOINTS.auth.me, {
      headers: { Authorization: `Bearer ${token}` },
    })
  },
  refresh() {
    return http.post<ApiResponse<{ token?: string }>>(ENDPOINTS.auth.refresh)
  },
  /** Call /auth/refresh with an explicit Bearer token to set a proper HttpOnly cookie. */
  refreshWithToken(token: string) {
    return http.post<ApiResponse<{ token?: string }>>(ENDPOINTS.auth.refresh, null, {
      headers: { Authorization: `Bearer ${token}` },
    })
  },
  changePassword(payload: ChangePasswordDto) {
    return http.put<ApiResponse<void>>(ENDPOINTS.auth.password, payload)
  },
  switchStore(storeId: string) {
    return http.post<ApiResponse<void>>(ENDPOINTS.auth.switchStore, { store_id: storeId })
  },
}
